import { render, staticRenderFns } from "./TagTableActive.vue?vue&type=template&id=202b954e&scoped=true"
import script from "./TagTableActive.vue?vue&type=script&lang=js"
export * from "./TagTableActive.vue?vue&type=script&lang=js"
import style0 from "./TagTableActive.vue?vue&type=style&index=0&id=202b954e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202b954e",
  null
  
)

export default component.exports